import { Routes, Route } from 'react-router-dom'
import { useContext, useEffect } from 'react'
import { AuthContext } from 'contexts/auth'
import Dashboard from 'pages/Dashboard'
import Task from 'pages/task/Task'
import Inventory from 'pages/inventory/Inventory'
import ManagementLayout from 'components/ManagementLayout'
import Product from 'pages/product/Product'
import Bin from 'pages/bin/Bin'
import LogsPage from 'pages/log/LogsPage'
import TransferPage from 'pages/transfer/TrasnferPage'
import EmployeePage from 'pages/employee/EmployeePage'

const PrivateRoutes: React.FC = () => {
  const { getMe } = useContext(AuthContext)!

  useEffect(() => {
    getMe()
  }, [])

  return (
    <Routes>
      <Route path='/' element={<Dashboard />} />

      <Route path='/:warehouseID/:warehouseCode' element={<ManagementLayout />}>
        <Route path='task' element={<Task />} />
        <Route path='transfer' element={<TransferPage />} />
        <Route path='inventory' element={<Inventory />} />
        <Route path='product' element={<Product />} />
        <Route path='bin' element={<Bin />} />
        <Route path='log' element={<LogsPage />} />
        <Route path='employee' element={<EmployeePage />} />
      </Route>
    </Routes>
  )
}

export default PrivateRoutes
